import { Event } from './modules/shared/entities/event';

export class EventClickEvent {
  public event: Event;
  constructor(event) {
    this.event = event;
  }
}
